import _get from "lodash/get";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.regexp.replace.js";
import querystring from 'querystring';

var AbSDK = function AbSDK(ServiceSDK, abUrl, abExperimentList, activateExperimentsAtPath) {
  // --- Public interface ---
  return {
    setActiveVariants: setActiveVariants,
    setActiveVariantsByPath: setActiveVariantsByPath,
    getVariantsFromABServer: getVariantsFromABServer
  };
  /**
   * name: setActiveVariants
   * purpose: notifies analytics of all variants the user has currently entered into
   * side effects: will update either --
   *                  `res.locals.nerdlayout.dynamicOpts.variantIds` on the server or
   *                  `window.variantIds` on the client.
   * params: variants (Array) -- list of variant IDs that are active
   *         res (Object) -- the response object if called on the server
   * returns: undefined
   */

  function setActiveVariants(variants, res) {
    if (res) {
      res.locals.nerdlayout = res.locals.nerdlayout || {};
      res.locals.nerdlayout.dynamicOpts = res.locals.nerdlayout.dynamicOpts || {};
      res.locals.nerdlayout.dynamicOpts.variantIds = variants;
    } else if (typeof window !== 'undefined') {
      window.nwVariantIds = variants;
      /* globals NWA */

      if (typeof NWA !== 'undefined') {
        NWA.metadata._setVariantIds();
      }
    }
  }
  /**
   * name: setActiveVariantsByPath
   * purpose: if you'd like to define a hardcoded list of experiments per path
   *          (e.g. not use @nerdwallet/react-redux-ab), this function will
   *          be used on the server, and can be called manually on the client
   *          on page transition.
   * side effects: calls setActiveVariants
   * params: allBucketedExperiments (Object) - experimentId <-> variantId mapping for the user
   *         path (String) - current path of request or window location
   *         serverResponse (Object) - if calling on the server, the response object to populate
   * returns: undefined
   */


  function setActiveVariantsByPath(allBucketedExperiments, path, serverResponse) {
    var activeVariants = [];
    var activeExperiments = activateExperimentsAtPath[path];
    activeExperiments.forEach(function (experiment) {
      if (!allBucketedExperiments[experiment].usesEEE) {
        activeVariants.push(allBucketedExperiments[experiment]);
      }
    });
    setActiveVariants(activeVariants, serverResponse);
  }
  /**
   * name: getVariantsFromABServer
   * purpose: gets all currently active variants from AB service (server side only)
   * params: nwid (String) -- current user's identify id
   *         serverRequest (Object) -- the request object
   *         serverResponse (Object) -- the response object
   * returns: ES6 Promise with all bucketed experiments
   */


  function getVariantsFromABServer(nwid, req) {
    var bucketedExperiments = {}; // --- Process any variants being forced by query parameter ---

    var variantsToGetFromAB = abExperimentList.filter(function (testName) {
      // Query parameter should be of format: ?test_<test_identifier>=<variant_name>
      // Request headers should be of format: test_<test_identifier>=<variant_name>
      var forcedVariantValue = getForcedVariantValue({
        testName: testName,
        req: req
      });

      if (forcedVariantValue) {
        // Bucket forced query parameter without hitting AB server.
        bucketedExperiments[testName] = {
          variantName: forcedVariantValue.toLowerCase(),
          // force lower case because A/B server returns its own "Control" with a capital C, so we can differentiate
          isForcedVariant: true
        };
        return false;
      }

      return true;
    });
    return new Promise(function (resolve, reject) {
      if (!variantsToGetFromAB.length) {
        return resolve();
      } // Query params tacked on manually due to error being returned from AB service
      // when encoding query params


      ServiceSDK.http({
        method: 'GET',
        url: "".concat(abUrl, "/GetVariants?TestName=").concat(variantsToGetFromAB.join(','), "&UUID=").concat(nwid, "&TestType=ABTest"),
        body: null,
        callback: _abPromiseCallback(resolve, reject),
        serverRequest: req
      });
    }).then(function (experimentsFromAB) {
      if (experimentsFromAB && Array.isArray(experimentsFromAB)) {
        // Preservation of order is guaranteed by AB server.
        variantsToGetFromAB.forEach(function (testName, index) {
          var experiment = experimentsFromAB[index];

          if (experiment) {
            bucketedExperiments[testName] = {
              variantID: experiment.VariantID,
              variantName: experiment.Variant.toLowerCase(),
              testID: experiment.TestID,
              ramp: experiment.Ramp,
              usesEEE: experiment.UsesEEE,
              customData: experiment.CustomData
            };
          }
        });
      }

      return Promise.resolve(bucketedExperiments);
    });
  } // --- Helpers ---


  function _abPromiseCallback(resolve, reject) {
    return function (err, resp, data) {
      if (!err && resp.statusCode === 200) {
        try {
          resolve(JSON.parse(data));
        } catch (e) {
          reject({
            err: e,
            resp: resp,
            data: data
          });
        }
      } else {
        reject({
          err: err,
          resp: resp,
          data: data
        });
      }
    };
  }
};

function getForcedVariantValue(_ref) {
  var testName = _ref.testName,
      req = _ref.req;
  var TEST_PREFIX = 'test_';

  var clientQuery =
  /* globals window */
  typeof window !== 'undefined' && _get(window, 'location.search', ''); // Query parameter should be of format: ?test_<test_identifier>=<variant_name>
  // Request headers should be of format: test_<test_identifier>=<variant_name>


  if (req) {
    var forcedVariantValue = req.query[TEST_PREFIX + testName] || req.get(TEST_PREFIX + testName);

    if (forcedVariantValue) {
      return forcedVariantValue;
    }
  } else if (clientQuery) {
    // querystring does not expect the `?` to be included but
    //  it is included in window.location.search
    var allForcedVariants = querystring.parse(clientQuery.replace('?', ''));
    return allForcedVariants[TEST_PREFIX + testName] || null;
  }

  return null;
}

export default AbSDK;